/**
 * Sanitize HTML by removing dangerous tags and event handlers.
 * Used for rendering SBA section content and Q&A answers.
 */
export function sanitizeHtml(html: string): string {
  if (!html) return '';
  const temp = document.createElement('div');
  temp.innerHTML = html;
  const dangerousTags = temp.querySelectorAll('script, style, iframe, object, embed, link, meta, base');
  dangerousTags.forEach(el => el.remove());
  const allElements = temp.querySelectorAll('*');
  allElements.forEach(el => {
    const attrs = Array.from(el.attributes);
    attrs.forEach(attr => {
      const name = attr.name.toLowerCase();
      if (name.startsWith('on') ||
          (name === 'href' && attr.value.toLowerCase().startsWith('javascript:')) ||
          (name === 'src' && attr.value.toLowerCase().startsWith('javascript:'))) {
        el.removeAttribute(attr.name);
      }
    });
  });
  return temp.innerHTML;
}
